import { GetCulpritImageTabsAlertsQueryParamType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritImageTabsAlerts/getCulpritImageTabsAlertsQuery.type';
import { getCulpritImageTabsAlertsQueryFunctions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritImageTabsAlerts/getCulpritImageTabsAlertsQueryFunctions';
import { queryOptions } from '@tanstack/react-query';

const getCulpritImageTabsAlertsQueryOptions = (
  params: GetCulpritImageTabsAlertsQueryParamType,
) =>
  queryOptions({
    queryKey: ['GET_CULPRIT_IMAGE_TABS_ALERTS', params],
    queryFn: () => getCulpritImageTabsAlertsQueryFunctions(params),
  });
export default getCulpritImageTabsAlertsQueryOptions;
